import { Identifiable, Resource } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function unAssignManagerFromResource(httpClient: HttpClient) {
  return (resource: Identifiable<Resource>, manager: Identifiable<Resource>) =>
    httpClient.sendHttpRequest<void>({
      endpoint: `/resources/${resource.uuid}/managers/${manager.uuid}`,
      method: HttpMethods.DELETE,
    });
}

export { unAssignManagerFromResource };
